import {Palette} from 'hubbl-shared';
import {useCallback} from 'react';
import {Api} from '../../api';
import {AssetIconLogOut} from '../../assets';
import {persistor} from '../../store';
import {TextBodyMedium} from '../text/TextBodyMedium';
import {DropdownContainer} from './DropdownContainer';
import {DropdownItem} from './DropdownItem';
import {useI18n} from '../../hooks';

interface UserInfoDropdownProps {
  isOpen: boolean;
  onClose: () => void;
}

export const UserInfoDropdown = ({isOpen, onClose}: UserInfoDropdownProps) => {
  const t = useI18n();
  const onLogout = useCallback(async () => {
    await Api.user.onLogOut();
    await persistor.purge();
    window.location.reload();
  }, []);

  if (!isOpen) return null;

  return (
    <DropdownContainer align={'left'}>
      <DropdownItem onClick={onLogout}>
        <AssetIconLogOut color={Palette.systemError} />
        <TextBodyMedium color={Palette.systemError} text={t.auth.logout} />
      </DropdownItem>
    </DropdownContainer>
  );
};
